import * as z from "zod";

export const serverResponse = z.object({
  dates: z.array(
    z.object({
      date: z.string(),
      slots: z.array(z.object({ endDate: z.string(), startDate: z.string() })),
    }),
  ),
});
